<div>
    <img src='/assets/images/ptn.png'>
</div>